import Requests from './Requests/Requests'
import { SnackbarProvider } from 'notistack'
import { Container, Paper } from '@mui/material'
import { useResponsableCreateLogic } from 'hooks'
import { CreateHeader } from 'pages/logged/admin/components'
import { DataFormResponsable } from 'components/forms/display'
import { BreadcrumbsList, Line } from 'components/data_display'

/**
 * Componente funcional que renderiza la página para crear un nuevo tutor.
 * Utiliza un hook personalizado para encapsular la lógica del formulario, 
 * y componentes de Material UI para estructurar la interfaz gráfica.
 *
 * @returns {JSX.Element} Elemento JSX que representa la página de creación de un nuevo tutor.
 */
export default function CreateResponsable() {
  const { createResponsable, handleSubmit, headerRef, register, errors } = useResponsableCreateLogic({ requests: new Requests() })

  return (
    <Container maxWidth={false} sx={{ mt: 5 }}>
      <form className="form w-100 fv-plugins-bootstrap5 fv-plugins-framework" onSubmit={handleSubmit(createResponsable)}>
        <BreadcrumbsList breadcrumbsList={[
          { to: "/", label: "Inicio" },
          { to: "./../", label: "Tutores" },
          { to: "./", label: "Crear tutor", actualItem: true },
        ]} />

        <Paper elevation={2} sx={{ mx: 8, my: 2, pb: 5 }}>
          <CreateHeader
            ref={headerRef}
            title={"Crear tutor"} />

          <Line />

          <DataFormResponsable register={register} errors={errors} />
        </Paper>

        <SnackbarProvider autoHideDuration={3000} />
      </form>
    </Container>
  )
}